import { ONBOARDING_STEP } from 'src/data/onboarding';
import { SPOTLIGHT_TYPE } from '../components/Spotlight';
import { buildTarget } from './utils';

export const STEPS_PD_DATA = [
  {
    id: ONBOARDING_STEP.pdGenerationRewrite,
    target: buildTarget([
      '[data-onboarding="ProjectEditView"]',
      '[data-onboarding="PanelGeneration"]',
    ]),
    content: {
      title: 'Rewrite Descriptions',
      description:
        'Use different styles and other parameters to configure Anyword. When you’re done, click on the Generate button to get new copy variations.\n' +
        'You can also review and edit your original description at any time. Make sure it depicts your product accurately.',
    },
    options: {
      placement: 'right-start',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.rounded }],
    },
  },
  {
    id: ONBOARDING_STEP.pdGenerationAdvanced,
    target: buildTarget([
      '[data-onboarding="ProjectEditView"]',
      '[data-onboarding="PanelGeneration"]',
    ]),
    content: {
      title: 'Example sets',
      description:
        'Customize Anyword’s writing style by defining a set of examples. You can create and save unlimited example sets.',
    },
    options: {
      placement: 'right-start',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.rounded }],
    },
  },

  {
    id: ONBOARDING_STEP.pdDraftVariations,
    target: buildTarget([
      '[data-onboarding="ProjectEditView"]',
      '[data-onboarding="ListDrafts"]:first-of-type',
      '>',
      '[data-onboarding="VariationDraft"]',
    ]),
    content: {
      title: 'Copy Variations',
      description:
        'Click on a variation to edit it.\n' +
        'Whenever you edit a variation, Anyword will update its Predictive Performance Score.\n' +
        'Saving variations helps Anyword AI improve.\n' +
        'The more variations you save, the more accurate the following variations will get.',
    },
    options: {
      placement: 'left-start',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.rounded }],
    },
  },
  {
    id: ONBOARDING_STEP.pdPredictiveScore,
    target: buildTarget([
      '[data-onboarding="ProjectEditView"]',
      '[data-onboarding="VariationDraft"]',
      '[data-onboarding="Score"]',
    ]),
    content: {
      title: 'Predictive Performance Score',
      description:
        'Trained on $250M worth of ad spend, Anyword’s score evaluates copy according to its potential to engage.\n' +
        'Use it to get immediate feedback, optimize your copy, and make better decisions.',
    },
    options: {
      placement: 'bottom-end',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.circle }],
    },
  },
  {
    id: ONBOARDING_STEP.pdDetailsVariationActions,
    target: buildTarget([
      '[data-onboarding="ProjectEditView"]',
      '[data-onboarding="VariationDraft"]',
      '[data-onboarding="Actions"]',
      '[data-onboarding="SaveButton"]',
    ]),
    content: {
      title: 'Action Buttons',
      description:
        'Hover over a variation to display its action buttons and score ‘Details’ button.\n' +
        'Saving variations helps Anyword improve. The more variations you save, the more accurate your copy variations will get.',
    },
    options: {
      placement: 'left-start',
      showOverlay: true,
      spotlights: [
        {
          type: SPOTLIGHT_TYPE.rounded,
          padding: { top: 8, bottom: 8, left: 138 },
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEP.pdDetailsPanel,
    target: buildTarget([
      '[data-onboarding="ProjectEditView"]',
      '[data-onboarding="VariationDetailsView"]',
    ]),
    content: {
      title: 'Score Panel',
      description:
        'Clicking on the score Details button will open the score panel.\n' +
        'Use it to gain insights into your copy and have a better understanding of your score.\n' +
        'The score panel is updated every time you make edits to your copy variation.',
    },
    options: {
      placement: 'left',
      showOverlay: true,
      spotlights: [
        {
          type: SPOTLIGHT_TYPE.rounded,
          padding: 0,
        },
      ],
    },
  },
];
